import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useTrackFiltersRemoved } from "@air/analytics";
import { Minus } from "@air/next-icons";
import { IconButton } from "@air/primitive-icon-button";
import { memo, useCallback } from "react";
import { CollapsibleCard } from "~/components/CollapsibleCard";
import { FilterCardFooter } from "~/components/Filters/FilterCardFooter";
import { FilterSelect } from "~/components/FiltersMenu/FilterSelect";
import { baseFiltersOptions } from "~/components/FiltersMenu/types";
import { customFieldIconMap } from "~/constants/customFieldIconMap";
import { FILTER_CARD } from "~/constants/testIDs";
import { useTemporaryFeatureFlags } from "~/hooks/useTemporaryFeatureFlags";
import { filterTypeToTrackingType } from "~/store/filters/utils";
export const FilterCard = /*#__PURE__*/ memo((param)=>{
    let { children, onClearClick, currentFilter, onFilterTypeChange, currentCustomField, getFiltersOptions, trackLocation, onRemoveFilter } = param;
    const { trackFiltersRemoved } = useTrackFiltersRemoved();
    const { searchImprovements } = useTemporaryFeatureFlags();
    /**
     * @TODO - Update this testid to not be dynamic based on customField name or currentFilter.
     */ const testId = (currentCustomField === null || currentCustomField === void 0 ? void 0 : currentCustomField.id) ? "".concat(FILTER_CARD, "-").concat(currentCustomField.name) : "".concat(FILTER_CARD, "-").concat(currentFilter);
    const onFilterDelete = useCallback(()=>{
        const filter = {
            type: currentFilter,
            customField: currentCustomField
        };
        onRemoveFilter(filter);
        trackFiltersRemoved({
            types: filterTypeToTrackingType(filter.type),
            location: trackLocation,
            builderType: "filter-builder"
        });
    }, [
        currentCustomField,
        currentFilter,
        onRemoveFilter,
        trackLocation,
        trackFiltersRemoved
    ]);
    if (searchImprovements) {
        const filter = baseFiltersOptions[currentFilter];
        var _currentCustomField_name;
        const title = (_currentCustomField_name = currentCustomField === null || currentCustomField === void 0 ? void 0 : currentCustomField.name) !== null && _currentCustomField_name !== void 0 ? _currentCustomField_name : filter.label;
        const Icon = (currentCustomField === null || currentCustomField === void 0 ? void 0 : currentCustomField.type.title) ? customFieldIconMap[currentCustomField.type.title] : filter.icon;
        return /*#__PURE__*/ _jsxs("div", {
            className: "flex flex-col gap-2 border-b border-b-grey-5 px-2 py-3 last:border-0 md:mx-3 md:px-1 md:py-3",
            "data-testid": testId,
            children: [
                /*#__PURE__*/ _jsxs("div", {
                    className: "flex items-center justify-between",
                    children: [
                        /*#__PURE__*/ _jsxs("div", {
                            className: "flex items-center gap-1",
                            children: [
                                !!Icon && /*#__PURE__*/ _jsx(Icon, {
                                    className: "size-4 text-grey-10 md:size-3 md:text-grey-12"
                                }),
                                /*#__PURE__*/ _jsx("div", {
                                    className: "truncate text-14 font-semibold text-grey-10 md:text-12 md:text-grey-12",
                                    "data-testid": "FILTER_CARD_TITLE",
                                    children: title
                                })
                            ]
                        }),
                        /*#__PURE__*/ _jsx(IconButton, {
                            appearance: "ghost",
                            color: "grey",
                            label: "Remove filter",
                            size: "small",
                            onClick: onFilterDelete,
                            children: /*#__PURE__*/ _jsx(Minus, {
                                className: "size-4 text-grey-12"
                            })
                        })
                    ]
                }),
                children
            ]
        });
    }
    return /*#__PURE__*/ _jsx(CollapsibleCard, {
        testId: testId,
        header: /*#__PURE__*/ _jsx(FilterSelect, {
            getFiltersOptions: getFiltersOptions,
            onFilterSelect: onFilterTypeChange,
            currentFilter: currentFilter,
            currentCustomField: currentCustomField
        }),
        footer: /*#__PURE__*/ _jsx(FilterCardFooter, {
            onClearClick: onClearClick,
            onDeleteClick: onFilterDelete
        }),
        children: /*#__PURE__*/ _jsx("div", {
            className: "p-1",
            children: children
        })
    });
});
FilterCard.displayName = "FilterCard";
